import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';
import env from "react-dotenv";
import imageIcon from '../../assets/image.svg';
import Isvg from 'react-inlinesvg';
import removeImageIcon from '../../assets/remove-image.svg';
import axios from 'axios';
import Switch from './switch';
import { API_ENDPOINT, CDN_URL } from '../../constants';

import {
    Modal, ModalHeader, ModalFooter, ModalBody, FormGroup, Input, Button
} from 'reactstrap';

class MediaGallery extends Component {
    constructor(props) {
        super(props);
        this.dropzone = React.createRef()
        this.removeImage = this.removeImage.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.state = {
            files: [],
            imagesLayout: [],
            _uploading: [],
            isOpen: false,
            search: '',
            disableCache: false
        };
    }


    componentDidMount() {
        let files = [];
        let imagesLayout = [];

        if (this.props.value) {
            for (let i = 0; i < this.props.value.length; i++) {
                files.push(this.props.value[i]);
                imagesLayout.push(i);
            }
        }

        this.setState({
            files: files,
            imagesLayout: imagesLayout,
        });
    }


    componentDidUpdate(prevProps, prevState) {
        console.log(this.props.value);

        if (!prevProps.value && this.props.value && this.props.value.length) {
            let files = [];
            let imagesLayout = [];

            if (this.props.value) {
                for (let i = 0; i < this.props.value.length; i++) {
                    files.push(this.props.value[i]);
                    imagesLayout.push(i);
                }
            }

            this.setState({
                files: files,
                imagesLayout: imagesLayout,
            });
        }
    }


    removeImage(idx) {
        console.log(idx);

        let files = this.state.files.slice(0, idx).concat(this.state.files.slice(idx + 1, this.state.files.length))
        let imagesLayout = this.state.imagesLayout.slice(0, idx).concat(this.state.imagesLayout.slice(idx + 1, this.state.imagesLayout.length))
        let _uploading = this.state._uploading.slice(0, idx).concat(this.state._uploading.slice(idx + 1, this.state._uploading.length))
        this.setState({
            files: files,
            imagesLayout: imagesLayout,
            _uploading: _uploading
        });
    }


    async onDrop(imageFiles) {

        let imagesLayout = [];
        let images = [];
        let _uploading = [];

        for (let i = 0; i < imageFiles.length; i++) {
            let formData = new FormData();
            formData.append('file', imageFiles[i]);
            let name = this.state.files.length + i;

            axios.post(API_ENDPOINT.replace('testapi', 'api') + this.props.endpoint, formData, {
                headers: {
                    Accept: 'application/json',
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                },
                onUploadProgress: (progressEvent) => {
                    let _uploading = this.state._uploading;
                    _uploading[name] = { progress: (progressEvent.loaded * 100) / progressEvent.total };

                    this.setState({
                        _uploading: _uploading,
                    })
                }
            }).then((response) => {

                let img = response.data;

                if (img.error) {
                    img = null;
                }

                this.props.onChange(img);
                this.setState({
                    _loading: null
                })

                let files = this.state.files;
                let _uploading = this.state._uploading;
                files[name] = img;
                _uploading[name] = null;

                this.setState({
                    _uploading: _uploading,
                    files: files
                }, () => {
                    this.props.onChange(this.state.files);
                })

            }).catch((error) => {
                this.props.onChange(null);
                this.setState({
                    _loading: null
                })
            })

            images.push(null);
            imagesLayout.push(i);
            _uploading.push({ progress: 0 });
        }

        this.setState({
            files: this.state.files.concat(images),
            imagesLayout: this.state.imagesLayout.concat(imagesLayout),
            _uploading: this.state._uploading.concat(_uploading)
        }, () => {
            let files = [];
            for (let i = 0; i < this.state.imagesLayout.length; i++) {
                files.push(this.state.files[this.state.imagesLayout[i]]);
            }

            this.props.onChange(files);
        });
    }


    onLayoutChange(layout) {
        let arr = [];
        for (let i = 0; i < layout.length; i++) {
            arr.push({ idx: layout[i].i, position: layout[i].y * 3 + layout[i].x });
        }

        arr.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0); });
        let imagesLayout = [];
        for (let i = 0; i < arr.length; i++) {
            imagesLayout.push(parseInt(arr[i].idx));
        }

        this.setState({
            imagesLayout: imagesLayout
        }, () => {
            let files = [];
            for (let i = 0; i < this.state.imagesLayout.length; i++) {
                files.push(this.state.files[this.state.imagesLayout[i]]);
            }

            this.props.onChange(files);
        });
    }


    search = () => {
        fetch(API_ENDPOINT.replace('testapi', 'api') +  `/data/products/${this.props.vindCollection ? 'vind/' : ''}images/search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
            },
            body: JSON.stringify({ search: this.state.search }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.error) {
                    this.setState({ searchImages: [] });
                    return;
                }
                this.setState({ searchImages: Array.isArray(result) ? result : [] });
            })
            .catch((err) => {
                this.setState({ searchImages: [] });
            })
    }

    render() {

        let images = [];

        if (this.state.files) {
            let x = 0;
            let y = 0;
            for (let i = 0; i < this.state.files.length; i++) {
                let layout = { i: i.toString(), x: x, y: y, w: 1, h: 1 };
                let item = {
                    content: (
                        <div className="image" key={i.toString()} data-grid={layout}>
                            <div className="image-wrap">
                                {this.state.files[i] ? <img src={`${CDN_URL}/bb-derivatives/derivatives/${this.state.files[i].bildbankId}/thumb_w400.webp`} /> : null}
                                {
                                    this.state._uploading[i] ?
                                        <div className="progress-wrap">
                                            <div className="progress"><div style={{ width: this.state._uploading[i].progress + '%' }}></div></div>
                                            <span>{Math.round(this.state._uploading[i].progress) + '%'}</span>
                                        </div> : null
                                }
                                {!this.state._uploading[i] ?
                                    <button className={'delete'} onClick={() => this.removeImage(i)}>
                                        <Isvg src={removeImageIcon} />
                                    </button>
                                    :
                                    null
                                }
                            </div>
                        </div>
                    )
                };
                images.push(item);
                x++;
                if (x >= 3) {
                    y++;
                    x = 0;
                }
            }
        }


        return (
            <div className={`media-gallery ${this.props.error ? 'media-gallery-error' : ''}`}>
                <div ref={(ref) => this.dropzone = ref}>
                    <Dropzone
                        onDrop={this.onDrop}
                        className='dropzone'
                        activeClassName='active-dropzone'
                        multiple={true}>
                    </Dropzone>
                    <div className="bottom-content">
                        <p><Isvg src={imageIcon} /> <span>Upload a file</span> or <a href="#" onClick={() => this.setState({isOpen: true})}>select from bildbank</a></p>
                    </div>

                    <GridLayout
                        className="grid-layout"
                        onLayoutChange={this.onLayoutChange}
                        width={this.dropzone.offsetWidth}
                        margin={[10, 10]}
                        rowHeight={110}
                        compactType={'horizontal'}
                        isResizable={false}
                        horizontalCompact={true}
                        useCSSTransforms={false}
                        cols={3}
                    >
                        {images.map((image, idx) => image.content)}
                    </GridLayout>
                </div>

                <Modal isOpen={this.state.isOpen} size="lg">
                    <ModalBody className='search-images-modal-body'>
                        <FormGroup>
                            <Switch label={'Disable cache'} value={this.state.disableCache} onChange={(val) => this.setState({disableCache: val})} />
                        </FormGroup>
                        <FormGroup>
                            <Input type="text" placeholder={'Search'.translate(this.props.lang)} onChange={(e) => this.setState({ search: e.target.value })} value={this.state.search} />
                            <Button onClick={this.search}>{'Search'.translate(this.props.lang)}</Button>
                        </FormGroup>
                        <div className='search-images'>
                            {this.state.searchImages ?
                                this.state.searchImages.map((item, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            onClick={() => {
                                                let files = this.state.files;
                                                let imagesLayout = this.state.imagesLayout;

                                                let idx = -1;
                                                for (let i = 0; i < files.length; i++) {
                                                    if (files[i] && files[i].id == item.id) {
                                                        idx = i;
                                                        break;
                                                    }
                                                }

                                                if (idx != -1) {
                                                    files.splice(idx, 1);
                                                    imagesLayout.splice(idx, 1);
                                                } else {
                                                    files.push({bildbankId: item.id});
                                                    imagesLayout.push(files.length - 1);
                                                }

                                                this.setState({
                                                    imagesLayout,
                                                    files
                                                }, () => {
                                                    this.props.onChange(this.state.files);
                                                })
                                            }}
                                            className={this.props.value && this.props.value.filter((val) => val.id == item.id).length ? 'active' : ''}
                                        >
                                            <img src={`${CDN_URL}/bb-derivatives/derivatives/${item.id}/thumb_w1200.webp`} />
                                        </div>
                                    )
                                })
                                : null
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button type="submit" color="danger" onClick={() => this.setState({ isOpen: false })}>
                            {'Close'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default MediaGallery;